/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_TitleInputs */

const en_fw_tpl_title = /** @type {(inputs: Fw_Tpl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans that already shipped`)
};

const id_fw_tpl_title = /** @type {(inputs: Fw_Tpl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana yang sudah jadi`)
};

/**
* | output |
* | --- |
* | "Plans that already shipped" |
*
* @param {Fw_Tpl_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_title = /** @type {((inputs?: Fw_Tpl_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_title(inputs)
	return en_fw_tpl_title(inputs)
});